import { BaseMenu } from "./BaseMenu";

import { MenuContainer } from "./logic/MenuContainer";

import { MenuElement } from "./logic/MenuElement";

export class Menu extends BaseMenu {
    createMenuElementInternal() {
        return new MenuElement(this._table);
    }
}

export class Container extends BaseMenu {
    createMenuElementInternal() {
        return new MenuContainer(this._table);
    }
}
//# sourceMappingURL=Menu.js.map
